const colors = {
  primary: '#5843e4',
  secondary: '#8186a0',
  backgroundLight: '#f9f9fc',
}

// '#5843e4',
export default colors
